import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Hourglass } from '@phosphor-icons/react';
import { Button } from '@/components/ui-kit/button';
import { Card } from '@/components/ui-kit/card';
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '@/components/ui-kit/empty';
import { APP_PATHS } from '@/constant/app-paths';
import { SoonBadge } from '../../components/soon-badge/soon-badge';

/** A settings page that is on the navigation map but not built yet. `name` is its translation key. */
export const SettingsSoonPage = ({ name }: { name: string }) => {
  const { t } = useTranslation();
  return (
    <Card>
      <Empty>
        <EmptyHeader>
          <EmptyMedia variant="icon">
            <Hourglass />
          </EmptyMedia>
          <SoonBadge />
          <EmptyTitle>
            <h1>{t(name)}</h1>
          </EmptyTitle>
          <EmptyDescription>{t('SOON_PAGE_DESCRIPTION')}</EmptyDescription>
        </EmptyHeader>
        <EmptyContent>
          <Button variant="outline" asChild>
            <Link to={APP_PATHS.SETTINGS}>{t('BACK_TO_SETTINGS')}</Link>
          </Button>
        </EmptyContent>
      </Empty>
    </Card>
  );
};
